import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { authActions } from "../../../core/auth";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import H2 from "../../components/h2";
import H3 from "../../components/h3";
import P from "../../components/p";
import A from "../../components/a";
import Button from "../../components/button";
import ClickTest from "./click-test";
import bridgeGif from "./kohi-click-test-bridge.gif";
import autoClickerParticles from "./auto-clicker-particles.jpg";
import "./style.css";

class KohiClickTest extends React.PureComponent {
  // componentDidMount() {
  //   const desktop = document.getElementById("twitter-quote-trustbox-desktop");
  //   const loadFromElement = () => {
  //     if (window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(desktop);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // }

  // shouldComponentUpdate() {
  //   return false;
  // }

  render() {
    return (
      <div>
        {/* <SaleBanner
          loggedIn={this.props.loggedIn}
          premium={this.props.premium}
          signInWithGoogle={this.props.signInWithGoogle}
          fromClickTest={true}
        /> */}
        <Main isBlog>
          <Helmet>
            <title>
              Kohi Click Test 2021: BEST way to Track & Boost your CPS
            </title>
            <meta
              name="description"
              content="Find Out Your Clickspeed with the BEST Click Test, how do YOU compare with the TOP PvPers! Ghast can ..."
            />
          </Helmet>
          <Box isBlog>
            <H1 isBlog>
              Check your Clicks Per Second on the 2021 Kohi Click Test
            </H1>
            <P isBlog>
              Hey there, after a bit of nostalgia remembering the good old days
              of Kohi gods, MCPvP, MineHQ, Badlion and all the best pvpers.{" "}
              <A className="link-color" href="/">
                ghast.io
              </A>{" "}
              have decided to put up Kohi Click Test, this cps tester used to be
              on the official kohi website long ago.
            </P>

            <H2 isBlog>What is your Clicking Speed?</H2>
            <P isBlog>
              Here is an exact replica of the Click Test from the website of the
              Kohi minecraft server which closed long long ago. You can use it
              to check your clickspeed! You have 10 seconds to click as much as
              you can and your score will show on the CPS counter, how fast can
              you click?
            </P>

            <ClickTest />

            <H2 isBlog>Why is Clickspeed Important?</H2>
            <P isBlog>
              Basically, in Minecraft PvP, one of the biggest skills you can
              learn is rapidly pressing your mouse button while maintaining aim.
              The amount of times you press the mouse clicker in a second is
              known as CPS (Clicks Per Second). If you are new to all of this
              you could probably think of it like{" "}
              <A
                className="link-color"
                href="https://en.wikipedia.org/wiki/Double-click"
              >
                double clicking
              </A>{" "}
              but instead of stopping at double, you just keep going.
            </P>

            <img
              src={autoClickerParticles}
              alt="person autoclicking with too many particles"
              style={{ width: "100%", marginBottom: 20 }}
            />

            <H2 isBlog>Methods of Clicking</H2>
            <P isBlog>
              There are various methods of fast clicking, in order to get higher
              scores on click tests, and to perform better in minecraft pvp.
              Some are easier than others, and each has pros and cons!
            </P>
            <table
              className="click-methods-table"
              style={{ width: "100%", marginBottom: 30 }}
            >
              <tr>
                <th>Name</th>
                <th>Difficulty</th>
                <th>Clickspeed</th>
              </tr>
              <tr>
                <td>Regular</td>
                <td>Easy</td>
                <td>3-9</td>
              </tr>
              <tr>
                <td>Jitter</td>
                <td>Hard</td>
                <td>10-14</td>
              </tr>
              <tr>
                <td>Butterfly</td>
                <td>Extreme</td>
                <td>15-25</td>
              </tr>
              <tr>
                <td>Drag</td>
                <td>Extreme</td>
                <td>25-100</td>
              </tr>
            </table>
            <H3 isBlog>Regular Clicking</H3>
            <P isBlog>
              This is just the normal run of the mill clicking that your mum or
              dad might do if you told them to click the mouse fast. It usually
              would start at about 3-6 clicks a second but some people can get
              as high as 7 or even 9 doing it. A pro of this method is that it's
              pretty easy to keep good aim, con is that it's hard to get high
              cps, usually you would only have average clicks per second.
            </P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/AYz3mzP_owY"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />

            <H3 isBlog>Jitter Clicking</H3>
            <P isBlog>
              This is where you tense or spasm your arm or hand, the shaking
              motion allows for much higher frequency of clicks on a click
              tester. At first it will be very hard to do for long, you will
              probably have to do short bursts and slowly build up, and it will
              be almost impossible to aim at first. There are PvPers who have
              been jitter clicking for so long now that they can control the
              shaking so well that it looks like they aren't even moving their
              hand or finger such as StimpyPvP.
            </P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/1Rl78mwLkvs"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />

            <H3 isBlog>Butterfly Clicking</H3>
            <P isBlog>
              Butterfly was a more recent discovery compared to jitter, it is a
              very controversial method of clicking and is not allowed on many
              servers. It is possible to get the fastest CPS with the most
              amount of control with this method though. It works by using 2
              fingers, and slamming them down on the mouse alternating. Lifting
              one up while the other is slamming down, the slam of the finger on
              the mouse when done correctly can create multiple clicks, because
              it's causing a vibration and rattling the mouse clicker, usually
              at least 2 clicks, but sometimes 3 or 4 from each click. Another
              reason is its controversial is some mouses are a lot better for it
              than others, and sometimes people get worn out mouses which can do
              it very easily. Anyway because you are only moving your fingers
              compared to shaking your hand, then this method is easy to
              control. It can reach speeds of 25 CPS. This is amazing on a
              clicking speed test.
            </P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/hBqqy4jx1HE"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />

            <H3 isBlog>Drag Clicking</H3>
            <P isBlog>
              Drag isn't really practical, and can't really be used in PvP, but
              basically if you have a sticky finger mouse, depending on the
              friction between the mouse clicker and your finger, you can
              bascially drag or rub your finger down the mouse and register 100s
              of clicks in a single drag. This would be fast, technically it
              would be the fastest on a click speed test, it would have the best
              clicks per second unanimously.
            </P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/EAeGdlYTYao"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />

            <H2 isBlog>Uses of Clicking Fast</H2>

            <H3 isBlog>In a Minecraft Fight</H3>
            <P isBlog>
              Basically when engaging in Minecraft PvP Combat, you will be
              wanting to swing your sword at least 10 CPS, this way you can
              increase your likelyhood of hitting your enemy, and launching them
              into a combo!
            </P>

            <H3 isBlog>Bridging</H3>
            <P isBlog>
              Clicking fast can be used for quickly placing blocks underneath
              you, in multiple techniques such as StanMPL bridging (Bleeple
              stole it from me 😉), Breezily bridge, god bridging, and a few
              more. The advantages of this is pretty obvious and can be used in
              so many minecraft gamemodes. For instance it can be used in sky
              wars, to quickly rush other islands or get to the center chests.
              It can be used in hunger games as a stomper to quickly bridge over
              someone to stomp. It can be used in bed wars to quickly get to the
              other teams bed. The opportunities are pretty endless here.
            </P>
            <img
              src={bridgeGif}
              alt="clicks put to the test with kohi bridging"
              style={{ width: "100%", marginBottom: 20 }}
            />

            <H3 isBlog>Quickly putting up walls</H3>
            <P isBlog>
              In build uhc and most gamemodes which involve blocks, you can
              click fast to quickly get walls up between you and an enemy. To
              block yourself in, deflect arrows, trap an enemy, etc.
            </P>

            <H2 isBlog>Conclusion</H2>
            <P isBlog>
              Fast clicking speeds are pretty useful in Minecraft and this test
              can help you practice them! Also if you are looking for other ways
              to improve at minecraft pvp, be sure to sign up to Ghast, we will
              send out some Minecraft PvP Tips to help you along, and you always
              have the option to purchase our connection program if you want
              too!
            </P>
            <Button href="/">Check out Ghast Connection Tool</Button>
            {/* <div
              id="twitter-quote-trustbox-desktop"
              className="trustpilot-widget"
              data-locale="en-GB"
              data-template-id="53aa8912dec7e10d38f59f36"
              data-businessunit-id="5c3cae791aa59c0001976ef2"
              data-style-height="130"
              data-style-width="100%"
              data-theme="light"
              data-stars="4,5"
              data-schema-type="Organization"
              style={{ marginTop: 100, marginBottom: 60 }}
            >
              {" "}
              <a
                href="https://uk.trustpilot.com/review/ghast.io"
                target="_blank"
              >
                Trustpilot
              </a>{" "}
            </div> */}
          </Box>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.auth.authenticated,
  premium: state.premium,
});

const mapDispatchToProps = {
  ...authActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(KohiClickTest);



/** WEBPACK FOOTER **
 ** ./src/views/pages/kohi-click-test/index.js
 **/